import { Col, Row } from 'react-bootstrap';
import { Container } from '../styles';
import FilePreview from '../../../../components/FilePreview';
import { Dispatch, SetStateAction } from 'react';

interface CustomLogoTabI {
  imageFile: File | string | undefined;
  setImageFile: Dispatch<SetStateAction<File | string | undefined>>;
}

export default function CustomLogoTab({
  imageFile,
  setImageFile,
}: CustomLogoTabI) {
  return (
    <Row xs={1} md={1} lg={1}>
      <Col>
        <Container>
          <div className="card-title">
            Logomarca
          </div>
          <FilePreview
            selectedFile={imageFile}
            setSelectedFile={setImageFile}
            fileType="image"
            noDataLabel="Por favor, selecione uma imagem para ser a logomarca dessa empresa. Essa imagem poderá ser mostrada no My-Link, e-mails e cartas de VT, de acordo com as configurações definidas aqui."
          />
        </Container>
      </Col>
    </Row>
  );
}
